import { createFileRoute, redirect } from "@tanstack/react-router";

// Profile was merged into Settings, now a tab of Management.
export const Route = createFileRoute("/st-admin/profile/")({
	beforeLoad: () => {
		throw redirect({ to: "/st-admin/management", replace: true });
	},
});
